import * as timeModule from "@/lib/time";

export const COVERAGE_DATE_RANGE = {
  min: "1900-01-01",
  max: "2100-12-31",
} as const;

const COVERAGE_DATE_RANGE_MESSAGE = `Date must be between ${COVERAGE_DATE_RANGE.min} and ${COVERAGE_DATE_RANGE.max}`;

/**
 * Resolves the date parser lazily for coverage validation.
 */
function getDateParser() {
  if (!timeModule.date) {
    throw new Error("Coverage date validation requires the date parser.");
  }
  return timeModule.date;
}

/**
 * Returns a validation error when the coverage date is out of range.
 */
export function getCoverageDateRangeError({ value }: { value?: string }): string | undefined {
  if (!value) return undefined;
  const date = getDateParser();
  const parsed = date(value);
  if (!parsed.isValid()) return undefined;
  const minDate = date(COVERAGE_DATE_RANGE.min);
  const maxDate = date(COVERAGE_DATE_RANGE.max);
  if (parsed.isBefore(minDate, "day") || parsed.isAfter(maxDate, "day")) {
    return COVERAGE_DATE_RANGE_MESSAGE;
  }
  return undefined;
}

/**
 * Throws when coverage dates fall outside the supported range.
 */
export function assertCoverageDatesInRange({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): void {
  const startError = getCoverageDateRangeError({ value: startDate });
  if (startError) {
    throw new Error(startError);
  }
  const endError = getCoverageDateRangeError({ value: endDate });
  if (endError) {
    throw new Error(endError);
  }
}
